export const NAMESPACE = 'FormElements';

export const createFormTokenName = token => `${NAMESPACE}-${token}`;

export const createFormId = id => createFormTokenName(id);